// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lohT","footer":"styles_footer__1R0Xt","passCodeTooltip":"styles_passCodeTooltip__21MNY"};